
import React from 'react';
import { Task } from '@/types/task';
import { TaskListWrapper } from './TaskList/TaskListWrapper';

interface TaskListProps {
  tasks: Task[];
  onComplete: (task: Task) => void;
  onDelete: (taskId: string) => void;
  onEdit: (taskId: string, data: any) => void;
  onReactivate?: (task: Task) => void;
  isAdmin: boolean;
}

export const TaskList = (props: TaskListProps) => {
  return <TaskListWrapper {...props} />;
};

export default TaskList;
